import { createContext } from "react";
import { useUploadPolicyQuery } from "../../Global.state";

export const ConfigContext = createContext();
export const ConfigContextProvider = ({ children }) => {
    // Retrieve s3 configuration bucket for rich editor
    const { data: uploadPolicy } = useUploadPolicyQuery();

    return (
        <ConfigContext.Provider value={{ uploadPolicy }}>
            {children}
        </ConfigContext.Provider>
    )
}